<template>
  <b-tabs
    v-model="tabMenuActive"
    pills
    card
    vertical
    nav-wrapper-class="p-0"
  >
    <b-tab
        v-for="(tab, index) in permissionsMenuTabs"
        :key="index"
        :title="tab.name"
        class="py-0"
      >
        <keep-alive>
          <component
            :is="tab.component"
            :item-data="itemData"
          />
        </keep-alive>
      </b-tab>
  </b-tabs>
</template>

<script>
import { ref } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import MenuCameraPermissions from './MenuCameraPermissions.vue';
import MenuDevicePermissions from './MenuDevicePermissions.vue';
import MenuEventPermissions from './MenuEventPermissions.vue';
import MenuNetworkPermissions from './MenuNetworkPermissions.vue';
import MenuRecordPermissions from './MenuRecordPermissions.vue';
import MenuSystemPermissions from './MenuSystemPermissions.vue';

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup () {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const permissionsMenuTabs = ref([
      {
        name: t('hanwha_dvr.groups_permissions.menu.camera.name'),
        component: MenuCameraPermissions
      },
      {
        name: t('hanwha_dvr.groups_permissions.menu.device.name'),
        component: MenuDevicePermissions
      },
      {
        name: t('hanwha_dvr.groups_permissions.menu.event.name'),
        component: MenuEventPermissions
      },
      {
        name: t('hanwha_dvr.groups_permissions.menu.network.name'),
        component: MenuNetworkPermissions
      },
      {
        name: t('hanwha_dvr.groups_permissions.menu.record.name'),
        component: MenuRecordPermissions
      },
      {
        name: t('hanwha_dvr.groups_permissions.menu.system.name'),
        component: MenuSystemPermissions
      }
    ]);

    const tabMenuActive = ref(0);

    return {
      permissionsMenuTabs,
      tabMenuActive
    }
  }
}
</script>
